<template>
    <div class="my-2">
        <v-toolbar flat color="white"><v-spacer></v-spacer><v-text-field v-model="search" label="Search"></v-text-field></v-toolbar>
        <v-data-table :items="invoices" :headers="headers" :search="search" :rows-per-page-items="[10]">
             <template v-slot:items="props" >
               <td class="text-xs-center">
                 <v-icon v-if="props.item.status!='DRAFT'" @click="getOnlineUrl(props.item)">open_in_new</v-icon>
               </td>
                 <td class="text-xs-center">{{props.item.invoiceNumber}}</td>
                 <td class="text-xs-center">{{props.item.xeroContactName}}</td>
                 <td class="text-xs-center" v-if="props.item.customerOrganisation">{{props.item.customerOrganisation.name}}</td>
                 <td v-else></td>
                 <td class="text-xs-center">{{props.item.subTotal|currency}}</td>
                 <td class="text-xs-center">{{props.item.totalTax|currency}}</td>
                 <td class="text-xs-center">{{props.item.total|currency}}</td>
                 <td class="text-xs-center">{{props.item.amountDue|currency}}</td>
                 <td class="text-xs-center">
                     <v-chip v-if="props.item.status=='DRAFT'" color="blue" class="white--text">Draft</v-chip>
                     <v-chip v-if="props.item.status=='SUBMITTED'" color="light-green" class="white--text">Submitted</v-chip>
                     <v-chip v-if="props.item.status=='APPROVED'" color="light-green" class="white--text">Approved</v-chip>
                     </td>
                 <td class="text-xs-center">{{formatDate(props.item.date)}}</td>
                 <td class="text-xs-center">{{formatDate(props.item.dueDate)}}</td>
             </template>
        </v-data-table>
       </div>
</template>
<script>
import Api from '../services/Api'
import dateformat from "dateformat";
export default {
  props: ['billingSummaryId'],
    data(){
        return {
            invoices: [],
            search: '',
            headers: [
              {
                text: 'Action',
                align: 'center',
                sortable: false
              },
                {
        text: "Invoice Number",
        align: "center",
        value: 'invoiceNumber'
      },
      {
        text: "Xero Contact",
        align: "center",
        value: "xeroContactName"
      },
      {
        text: "Glue Organisation",
        align: "center",
        value: "customerOrganisation.name"
      },
       {
        text: "Total Excl VAT",
        align: "center",
        value: "subTotal"
      },
      {
        text: "VAT",
        align: "center",
        value: "totalTax"
      },
      {
        text: "Total Incl VAT",
        align: "center",
        value: "total"
      },
      {
        text: "Amount Owing",
        align: "center",
        value: "amountDue"
      },
      {
        text: "Status",
        align: "center",
        value: "status"
      },
      {
        text: "Sent Date",
        align: "center",
        value: "date"
      },
      {
        text: "Due Date",
        align: "center",
        value: "dueDate"
      }
            ]
        }
    },
    created(){
        this.initalize()
    },
    methods: {
        initalize(){
            this.getSystemInvoices()
        },
        getSystemInvoices(){
            Api().get('/systemInvoice/'+this.billingSummaryId).then(response=>{
                this.invoices = response.data
            })
        },
        formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    getOnlineUrl(item){
      Api().get('/xero/onlineInvoice/'+item.xeroTenantId+'/'+item.invoiceId).then(response=>{
        console.log(response.data.body.onlineInvoices[0].onlineInvoiceUrl)
        window.open(response.data.body.onlineInvoices[0].onlineInvoiceUrl, '_blank');
      })
    }
    }
}
</script>